import React from "react";
import styled, {css} from "styled-components";

const SelectAxisCard = ({axis, axisSelected, selectByAxis}) => {
    return(
        <Card
            $mode={axisSelected === axis.id}
            onClick={() => selectByAxis(axis.id)}
        >
            <p>
                {axis.name}
            </p>
        </Card>
    )
}

const Card = styled.div`
  border-radius: 10px;
  padding: 0.5em;
  &:hover {
    cursor: pointer;
    border: 1px solid var(--color-purple);

    p {
      color: var(--color-purple);
    }
  }
  ${(props) => {
    switch (props.$mode) {
        case true:
            return css`
          border: 1px solid var(--color-purple);

          p {
            color: var(--color-purple);
          }
        `;
        default:
            return css`
          background: rgba(166, 172, 181, 0.1);
          border: 1px solid transparent;
        `;
    }
}}
`

export default SelectAxisCard